import * as React from 'react'
import { ChevronRight } from 'lucide-react'

import { LocalizedLink } from '@rewardops/ui'

export type Breadcrumb = {
  label: string
  path?: string
}

interface IProps {
  crumbs: Breadcrumb[]
}

const Breadcrumbs = ({ crumbs }: IProps) => {
  return (
    <div className="flex gap-1">
      {crumbs?.map((crumb, index) => {
        const { label, path } = crumb
        return (
          <div
            id={`breadcrumb-${index}`}
            key={label}
            className="flex flex-row items-center gap-2"
          >
            {path ? (
              <LocalizedLink
                id={`breadcrumb-link-${index}`}
                className="text-sm font-normal"
                href={path}
              >
                {label}
              </LocalizedLink>
            ) : (
              <div
                id={`breadcrumb-link-${index}`}
                className="pr-4 text-sm font-normal"
              >
                {label}
              </div>
            )}
            {index !== crumbs.length - 1 && <ChevronRight size={20} />}
          </div>
        )
      })}
    </div>
  )
}

export default Breadcrumbs
